export default [
  {
    path: '/main/components',
    meta: {
      tag: 'list_components',
      name: 'Componentes',
      breadcrumb: 'Componentes'
    },
    component: () => import(/* webpackChunkName: "component-list" */ '@/views/main/settings/stock-registers/component/Index.vue'),
    children: [
      {
        path: '',
        name: 'listcomponents',
        meta: {
          tag: 'list_components',
          menu: 'settings',
          name: 'Componentes'
        },
        component: () => import(/* webpackChunkName: "component-list" */ '@/views/main/settings/stock-registers/component/List.vue')
      },
      {
        path: '/main/component/add',
        name: 'addcomponent',
        meta: {
          tag: 'add_component',
          menu: 'settings',
          name: 'Adicionar | Componente',
          breadcrumb: 'Adicionar Componente'
        },
        component: () => import(/* webpackChunkName: "component-add" */ '@/views/main/settings/stock-registers/component/Add.vue')
      },
      {
        path: '/main/component/:id',
        name: 'editcomponent',
        meta: {
          tag: 'edit_component',
          menu: 'settings',
          name: 'Editar | Componente',
          breadcrumb: 'Editar Componente'
        },
        component: () => import(/* webpackChunkName: "component-edit" */ '@/views/main/settings/stock-registers/component/Edit.vue')
      }
    ]
  },
]